$(document).ready(function () {
	$('.tabs__triggers-item').click(function (e) {
		e.preventDefault();
		$('.tabs__triggers-item').removeClass('active');
		$('.tabs__content-item').removeClass('active');
		$(this).addClass('active');
		$($(this).attr('href')).addClass('active');
	});

	$( '.help-accord__header' ).click( function( e ) {
		$( this ).toggleClass( 'active' ).next().slideToggle( 500 );
	});

	$('.help-list').slick({
		slidesToShow: 6,
		infinite: false,
		slidesToScroll: 1,
		arrows: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 641,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 441,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			}
		]
	});
});
